// Sentinel value used to filter records where a field (type, carrier_type, ...) is missing/unset.
// Must stay in sync with NONE_FLAG in oms-api-v2 (lib/typeCarrierFilter.js).
export const NONE_FILTER = '__NONE__'
